import { CurveAbstractTrade } from '../../common/curve-provider/curve-abstract-trade';

export class CurveFraxtalTrade extends CurveAbstractTrade {}
